<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-user"></span>
          <span>Configuración perfil</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textoSubtitulo" style="font-size: 18px;">  Búsqueda de perfiles</p>
      </div><br>

      <b-row>
        <b-col>

          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="descripcion" placeholder="Nombre del perfil"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerCatalogoAgenda"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Agregar perfil" variant="outline-primary"
                        @click="agregar()">Agregar perfil
              </b-button>
            </b-col>

          </b-row>

        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>

            <template v-slot:cell(fechaModificacion)="row">
              {{ row.item.fechaModificacion | formatoFechaCorta}}
            </template>

            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button title="Modificar descripción"
                          size="sm"
                          @click="modificarDescripcion(row.item)"
                          variant="outline-success"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button title="Modificar perfil"
                          size="sm"
                          @click="obtenerConfiguracionPerfil(row.item)"
                          variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo"
                          title="Activar permiso"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarEstatus(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else
                          title="Desactivar permiso"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarEstatus(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>

      </b-row>
    </b-card>
    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>

              <b-form-group align="left">
                <label for="nombreConfiguracion">Nombre</label>
                <b-input-group size="sm" class="mb-2" id="nombreConfiguracion">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombreConfiguracion" placeholder="Nombre del perfil"
                                v-model="$v.perfilCatalogo.nombreConfiguracion.$model"
                                :state="validateState('nombreConfiguracion')"
                                rows="3"
                                max-rows="6"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group align="left">
                <label for="descripcion">Descripcion</label>
                <b-input-group size="sm" class="mb-2" id="descripcion">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="html" placeholder="Descripción"
                                   v-model="$v.perfilCatalogo.descripcion.$model"
                                   :state="validateState('descripcion')"
                                   rows="3"
                                   max-rows="6"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                        Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </template>

    </b-modal>

    <b-modal
        v-model="modalDescripcion"
        :title="tituloDescripcion"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>

              <b-form-group align="left">
                <label for="nombreConfiguracion">Nombre</label>
                <b-input-group size="sm" class="mb-2" id="nombreConfiguracion">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombreConfiguracion" placeholder="Nombre del perfil"
                                v-model="$v.perfilCatalogo.nombreConfiguracion.$model"
                                disabled
                                :state="validateState('nombreConfiguracion')"
                                rows="3"
                                max-rows="6"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group align="left">
                <label for="descripcion">Descripcion</label>
                <b-input-group size="sm" class="mb-2" id="descripcion">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="html" placeholder="Descripción"
                                v-model="$v.perfilCatalogo.descripcion.$model"
                                :state="validateState('descripcion')"
                                rows="3"
                                max-rows="6"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                        Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </template>

    </b-modal>


    <b-modal
        v-model="modalDetalle"
        :title="tituloDetalle"
        size="xl"
        scrollable
    >

        <b-col align="right">
          <b-button v-b-tooltip.hover title="Agregar configuración perfil" variant="outline-primary"
                    @click="agregarConfiguracion()">Agregar configuración perfil
          </b-button>
        </b-col>

        <b-card class="bCardGlobal">
        <b-row>
          <b-col cols="12">
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosConfiguracion"
                :fields="fields1"
                :per-page="$registrosPorPaginaTabla"
                :current-page="paginaActual"
                responsive="true"
                class="parrafos"
                fixed>

              <template v-slot:cell(Acciones)="row">
                <b-button-group>
                  <b-button title="Modificar perfil"
                            size="sm"
                            @click="modificarConfiguracion(row.item)"
                            variant="outline-warning"
                  ><em class="fa fa-pencil"></em></b-button>
                  <b-button v-if="!row.item.registroActivo"
                            title="Activar permiso"
                            variant="outline-danger"
                            size="sm"
                            @click="activarDesactivarConfiguracion(row.item)"
                  ><em class="fa fa-undo"></em></b-button>
                  <b-button v-else
                            title="Desactivar permiso"
                            variant="outline-danger"
                            size="sm"
                            @click="activarDesactivarConfiguracion(row.item)"
                  >
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </b-button-group>

              </template>
            </b-table>
            <div align="center" v-if="loader">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-if="!loader">
              <b-alert v-if="datosConfiguracion.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
            <b-col v-if="!loader">
              <b-pagination
                  v-if="datosConfiguracion !== undefined && datosConfiguracion.length > 10"
                  align="center"
                  v-model="paginaActual"
                  :total-rows="datosConfiguracion.length"
                  :per-page="$registrosPorPaginaTabla"
                  aria-controls="my-table1"
              ></b-pagination>
            </b-col>
          </b-col>

        </b-row>
        </b-card>

      <template v-slot:modal-footer>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cerrar</b-button>
      </template>

    </b-modal>


    <b-modal
        v-model="modalConfiguracion"
        :title="tituloConfiguracion"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardarConfiguracionPerfil">
        <b-container fluid>
          <b-row>
            <b-col>

              <b-form-group align="left">
                <label for="nombreConfiguracion">Nombre</label>
                <b-input-group size="sm" class="mb-2" id="nombreConfiguracion">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombreConfiguracion" placeholder="Nombre del perfil"
                                v-model="$v.guardarConfiguracion.nombreConfiguracion.$model"
                                disabled
                                :state="validateState('nombreConfiguracion')"
                                rows="3"
                                max-rows="6"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

              <div class="row">

                <div class="col-6">
                  <b-form-group
                      label="Lista grupo"
                      label-align="left"
                      class="mginInputTrt"
                  >
                    <v-select
                        v-model="guardarConfiguracion.idGrupo"
                        :disabled = "guardarConfiguracion.idPerfil != null || guardarConfiguracion.idEspecialidad != null"
                        :options="grupo"
                        label="descripcionGrupo"
                        :reduce="(item) => item.idGrupo">
                    </v-select>
                  </b-form-group>
                </div>

                <div class="col-6">
                  <b-form-group
                      label="Lista perfil"
                      label-align="left"
                      class="mginInputTrt"
                  >
                    <v-select
                        v-model="guardarConfiguracion.idPerfil"
                        :disabled = "guardarConfiguracion.idGrupo != null || guardarConfiguracion.idEspecialidad != null"
                        :options="perfil"
                        label="nombrePerfil"
                        :reduce="(item) => item.idPerfil">
                    >
                    </v-select>
                  </b-form-group>
                </div>

                <div class="col-12">
                  <b-form-group
                      label="Lista especialidad"
                      label-align="left"
                      class="mginInputTrt"
                  >
                    <v-select
                        v-model="guardarConfiguracion.idEspecialidad"
                        :disabled = "guardarConfiguracion.idGrupo != null || guardarConfiguracion.idPerfil != null"
                        :options="especialidad"
                        label="nombreEspecialidad"
                        :reduce="(item) => item.idEspecialidad">
                      >
                    </v-select>
                  </b-form-group>
                </div>
              </div>
              <br><br>

            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                        Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModalConfiguracion()">Cancelar</b-button>
      </template>

    </b-modal>

  </div>
</template>

<script>
import Header from "@/components/Header";
//import configuracionPerfil from "@/views/configuracionPerfil.vue";
import {required} from "vuelidate/lib/validators";

export default {
  name: "CatalogoAgendaLinea",
  components: { Header },

  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    grupo: [],
    perfil: [],
    especialidad: [],
    datosTabla: [],
    fields: [
      {key: "idConfiguracion", label: "ID", sortable: true},
      {key: "nombreConfiguracion", label: "Nombre", sortable: true},
      {key: "descripcion", label: "Descripción", sortable: true},
      {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
      {key: "nombreUsuarioModificacion", label: "Usuario modificación", sortable: true},
      "Acciones"
    ],

    datosConfiguracion: [],
    fields1: [
      {key: "idConfiguracionPerfil", label: "ID", sortable: true},
      {key: "nombreConfiguracion", label: "Nombre", sortable: true},
      {key: "descripcionGrupo", label: "Nombre grupo", sortable: true},
      {key: "nombrePerfil", label: "Nombre perfil", sortable: true},
      {key: "nombreEspecialidad", label: "Nombre especialidad", sortable: true},
      "Acciones"
    ],

    paginaActual: 1,
    show: false,
    modalDetalle: false,
    modalConfiguracion: false,
    modalDescripcion: false,
    tituloDescripcion: '',
    tituloConfiguracion: '',
    tituloDetalle: '',
    tituloModal: '',
    guardarConfiguracion:{
      idConfiguracionPerfil: null,
      idConfiguracion: null,
      nombreConfiguracion: null,
      idGrupo: null,
      descripcionGrupo: null,
      idPerfil: null,
      nombrePerfil: null,
      idEspecialidad: null,
      nombreEspecialidad: null
    },
    perfilCatalogo: {
      idConfiguracion: null,
      nombreConfiguracion: null,
      descripcion: null,
    },
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null
    },
    loaderAcciones: false,
    loader: false,
  }),
  validations: {
    perfilCatalogo: {
      nombreConfiguracion: {required},
      descripcion: {},
    },
    guardarConfiguracion: {
      nombreConfiguracion: {required},
    }
  },

  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerCatalogoAgenda();
    this.listaPerfil();
    this.listaGrupo();
    this.listaEspecialidad();
  },

  methods: {

    modificarConfiguracion(item) {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.guardarConfiguracion = JSON.parse(JSON.stringify(item));
      this.guardarConfiguracion.nombreConfiguracion = this.perfilCatalogo.nombreConfiguracion
      this.modalConfiguracion = true;
    },

    cerrarModal() {
      this.show = false;
      this.modalDetalle = false;
      this.modalDescripcion = false;
      this.variableId = null;
    },

    cerrarModalConfiguracion(){
      this.modalConfiguracion = false;
    },

    modificarDescripcion(item){
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.perfilCatalogo = JSON.parse(JSON.stringify(item));
      this.tituloDescripcion = 'Modificar perfil';
      this.modalDescripcion = true;
    },

    agregar() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.perfilCatalogo = {
        idConfiguracion: null,
        nombreConfiguracion: null,
        descripcion: null,
      };
      this.tituloModal = 'Agregar perfil';
      this.show = true;
    },

    listaGrupo() {
      this.$http.post(this.$api + 'catalogoAgendaLinea/obtenergrupo').then(respuesta => {
        if (respuesta.data.data) {
          this.grupo = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },

    listaPerfil() {
      this.$http.post(this.$api + 'catalogoAgendaLinea/obtenerPerfil').then(respuesta => {
        if (respuesta.data.data) {
          this.perfil = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },

    listaEspecialidad() {
      this.$http.post(this.$api + 'catalogoAgendaLinea/obtenerEspecialidad').then(respuesta => {
        if (respuesta.data.data) {
          this.especialidad = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },


    submitGuardar() {
      this.$refs.submitGuardar.click();
    },
    guardar() {
      this.$v.perfilCatalogo.$touch();
      if (this.$v.perfilCatalogo.$anyError) {
        return;
      }
      if (!this.$v.perfilCatalogo.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'catalogoAgendaLinea/guardarPerfil', this.perfilCatalogo).then(respuesta => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El perfil se registró correctamente",
                });
                this.filtro.palabraClave = this.perfilCatalogo.nombreConfiguracion;
                this.obtenerCatalogoAgenda();
                this.modalDetalle = false;
                this.modalDescripcion = false;
              }
            }
        ).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "El perfil ya existe",
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },

    obtenerCatalogoAgenda(){
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + 'catalogoAgendaLinea/obtenerCatalogo', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosTabla.push(it);
              })
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },

    agregarConfiguracion() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
          this.guardarConfiguracion.idConfiguracionPerfil = null,
          this.guardarConfiguracion.idConfiguracion = this.perfilCatalogo.idConfiguracion,
          this.guardarConfiguracion.nombreConfiguracion = this.perfilCatalogo.nombreConfiguracion,
          this.guardarConfiguracion.idGrupo = null,
          this.guardarConfiguracion.idPerfil = null,
          this.guardarConfiguracion.idEspecialidad = null,
          this.modalConfiguracion = true;
          this.tituloConfiguracion = 'Agregar configuración perfil';
    },

    activarDesactivarEstatus(item) {
      const mensaje = item.registroActivo
          ? "¿Está seguro de desactivar el perfil?"
          : "¿Está seguro de activar el perfil?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idConfiguracion: item.idConfiguracion,
          }
          this.$http
              .post(
                  this.$api + 'catalogoAgendaLinea/activar_desactivar', parametros
              )
              .then((respuesta) => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El tipo de solicitud se actualizó correctamente",
                  });
                  this.obtenerCatalogoAgenda();
                }
              });
        }
      });
    },

    obtenerConfiguracionPerfil(item){
      this.modalDetalle = true;
      this.tituloDetalle = 'Modificar configuración perfil';
      this.datosConfiguracion = [];
      this.perfilCatalogo = JSON.parse(JSON.stringify(item));
      this.$http.post(this.$api + 'catalogoAgendaLinea/configuracionPefil?idConfiguracion=' + this.perfilCatalogo.idConfiguracion).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosConfiguracion.push(it);
              })
            }
            this.obtenerCatalogoAgenda();
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },

    guardarConfiguracionPerfil() {
      this.$v.guardarConfiguracion.$touch();
      if (this.$v.guardarConfiguracion.$anyError) {
        return;
      }
      if (!this.$v.guardarConfiguracion.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'catalogoAgendaLinea/guardarConfiguracionPf', this.guardarConfiguracion).then(respuesta => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El perfil se registró correctamente",
                });
                this.obtenerCatalogoAgenda();
                this.modalConfiguracion = false;
                this.modalDetalle = false;
              }
            }
        ).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "El perfil ya existe",
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },

    activarDesactivarConfiguracion(item) {
      const mensaje = item.registroActivo
          ? "¿Está seguro de desactivar el perfil?"
          : "¿Está seguro de activar el perfil?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idConfiguracionPerfil: item.idConfiguracionPerfil,
          }
          this.$http
              .post(
                  this.$api + 'catalogoAgendaLinea/activarDesactivarConfiguracion', parametros
              )
              .then((respuesta) => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El tipo de solicitud se actualizó correctamente",
                  });

                }
              });
        }
      });
    },


    validateState(name) {
      const {$dirty, $error} = this.$v.perfilCatalogo[name];
      return $dirty ? !$error : null;
    },

  }
};
</script>

<style scoped>
</style>